export default __webpack_public_path__ + "static/media/ins.2a571c99.svg";